import { SearchAppHomeType } from '@/schemas/SearchAppHomeSchema';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

type Props = {
  search: () => void;
};

export const useLogic = ({ search }: Props) => {
  const [showMore, setShowMore] = useState(false);

  const { setValue, getValues } = useFormContext<SearchAppHomeType>();

  const toggleCheckboxForMedicalSubject = ({
    medicalSubjectId,
  }: {
    medicalSubjectId: number;
  }) => {
    const currentValue = getValues('medical_subjects');
    if (currentValue.includes(medicalSubjectId)) {
      const newValue = currentValue.filter(
        (id: number) => id !== medicalSubjectId,
      );
      setValue('medical_subjects', newValue);
    } else {
      const newValue = [...currentValue, medicalSubjectId];
      setValue('medical_subjects', newValue);
    }

    search();
  };

  const toggleCheckboxForReportedAdditionalFee = ({
    reportedAdditionalFeeId,
  }: {
    reportedAdditionalFeeId: number;
  }) => {
    const currentValue = getValues('reported_additional_fees');
    if (currentValue.includes(reportedAdditionalFeeId)) {
      const newValue = currentValue.filter(
        (id: number) => id !== reportedAdditionalFeeId,
      );
      setValue('reported_additional_fees', newValue);
    } else {
      const newValue = [...currentValue, reportedAdditionalFeeId];
      setValue('reported_additional_fees', newValue);
    }

    search();
  };
  const reset = () => {
    setValue('medical_subjects', []);
    setValue('reported_additional_fees', []);
    setValue('page', 1);
    setValue('is_no_addition', false);

    search();
  };

  return {
    showMore,
    setShowMore,
    toggleCheckboxForMedicalSubject,
    toggleCheckboxForReportedAdditionalFee,
    reset,
  };
};
